import { BookOpen, Heart, Users, ArrowRight, MessageCircle, CheckCircle, Mail } from 'lucide-react';
import { ExampleContent, ParallaxCards, ParallaxContent, ParallaxContentWithChildren, ParallaxVideo } from '../components/ParallaxContent';
import { useEffect, useRef, useState } from 'react';
import { PreReleaseModal } from "../components/pre-release-modal"


export default function Home() {
  const [prayerModalOpen, setPrayerModalOpen] = useState(false);
  const [preReleaseModalOpen, setPreReleaseModalOpen] = useState(false)

  const onNavigate = (page) => {
    // onNavigate(page);
    window.location.href = page
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };


  const ReturnBG = ({ index, opacity, extraTailwind }) => {
    const url = [
      "https://www.thetransformationcollective.org/wp-content/uploads/2025/05/PHOTO-2025-04-23-15-45-59-5.jpg",
      "https://www.thetransformationcollective.org/wp-content/uploads/2025/05/PHOTO-2025-04-23-15-43-01-3.jpg",
      "https://www.thetransformationcollective.org/wp-content/uploads/2025/05/PHOTO-2025-04-23-15-45-59-2.jpg",
      "https://www.thetransformationcollective.org/wp-content/uploads/2025/05/PHOTO-2025-04-23-15-45-58.jpg",
      "https://www.thetransformationcollective.org/wp-content/uploads/2025/04/glory-hour.jpeg",
      "https://www.thetransformationcollective.org/wp-content/uploads/2025/05/PHOTO-2025-04-23-15-46-00-2.jpg"
    ];

    return (
      <div
        className={`h-full w-full absolute top-0 left-0 opacity-20 ${extraTailwind}`}
        style={{
          backgroundImage: `url(${url[index]})`, // or url[1] if you want fixed
          backgroundPosition: "center",
          backgroundSize: "cover",
          opacity
        }}
      ></div>
    );
  };


  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-50 via-white to-orange-50 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://www.thetransformationcollective.org/wp-content/uploads/2025/05/PHOTO-2025-04-23-15-43-01-4.jpg')] bg-center bg-cover"></div>
        <div className='absolute inset-0 bg-black/40'></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center mt-24">
          <div className="animate-fade-in-up">

            <h1 className="text-5xl md:text-7xl font-bold text-white font-serif mb-6 leading-tight">
              Transforming Lives,
              <span className="block text-amber-400">Leaders, and Nations</span>
            </h1>

            <p className="text-sm md:text-xl text-gray-100 mb-8 max-w-3xl mx-auto leading-relaxed">
              Latangela Rogers, known as The Transformer, is a visionary leader, author, and strategist helping individuals and organizations step into their divine assignment through leadership, faith, and transformation.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button
                onClick={() => scrollToSection('bio-preview')}
                className="px-8 py-4 bg-red-700 text-white rounded-full font-medium hover:bg-red-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center gap-2"
              >
                Learn More <ArrowRight size={20} />
              </button>
              <button
                onClick={() => onNavigate('contact')}
                className="px-8 py-4 bg-white text-red-700 rounded-full font-medium hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl border-2 border-red-700 transform hover:-translate-y-1"
              >
                Get in Touch
              </button>
            </div>
          </div>
        </div>
      </section>


      {/* Women Transform Retreat Highlight */}
      <section className="py-20 bg-gradient-to-br from-rose-50 via-pink-50 to-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Image */}
            <div className="rounded-2xl overflow-hidden shadow-2xl transform transition-all duration-500 hover:scale-105">
              <img
                src="http://roseofjericho-cd.org/wp-content/uploads/2026/05/womensTransform.jpeg"
                alt="Women Transform Retreat - A Christ-Centered Wellness Retreat for Women"
                className="w-full h-auto object-cover"
              />
            </div>

            {/* Content */}
            <div className="space-y-6">
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-2">Women Transform Retreat</h2>
                <p className="text-lg text-amber-700 font-semibold mb-4">
                  A Christ-Centered Wellness Retreat for Women
                </p>
                <p className="text-sm text-gray-600 uppercase tracking-wider font-semibold mb-4">
                  Theme: Naming What You Have Been Carrying
                </p>
              </div>

              <div className="space-y-3 text-gray-700">
                <p className="leading-relaxed">
                  Join us for a transformative retreat focused on <span className="font-semibold">Rest. Healing. Wholeness.</span>
                </p>
                <p className="leading-relaxed">
                  Through Scripture, prayer, and fellowship, experience restoration for your mind, body, and soul. Discover your worth in Christ and embrace healing from generational wounds.
                </p>
              </div>

              {/* Event Details */}
              <div className="bg-white text-black rounded-xl p-6 shadow-md border-l-4 border-rose-600 space-y-3">
                <div className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-rose-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <span className="text-sm"><span className="font-semibold">Friday, June 27, 2026</span> • 10 AM – 2 PM PST</span>
                </div>
                <div className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-rose-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span className="text-sm"><span className="font-semibold">Menifee, CA</span></span>
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <button
                  onClick={() => window.location.href = "https://www.eventbrite.com/e/woman-transform-retreat-june-2026-naming-what-you-have-been-carrying-tickets-1990343692563?aff=oddtdtcreator"}
                  className="flex-1 px-8 py-4 bg-rose-600 text-white rounded-full font-semibold hover:bg-rose-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center justify-center gap-2"
                >
                  Register Now
                  <ArrowRight size={18} />
                </button>
                <button
                  onClick={() => window.location.href = "/women-transform"}
                  className="flex-1 px-8 py-4 bg-white text-rose-600 rounded-full font-semibold hover:bg-rose-50 transition-all duration-300 shadow-lg hover:shadow-xl border-2 border-rose-600 transform hover:-translate-y-1"
                >
                  Learn More
                </button>
              </div>

              <p className="text-xs text-gray-500 text-center">
                Registration is open
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Published Section */}
      <section id="books-section" className="py-20 bg-gradient-to-br from-red-50 to-orange-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 animate-fade-in">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Published Works</h2>
            <div className="w-20 h-1 bg-red-700 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Books that inspire faith, encourage growth, and illuminate God's truth
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all duration-500 hover:scale-105 hover:shadow-2xl">
              <div className="relative h-64 bg-gradient-to-br from-red-600 to-orange-700 flex items-center justify-center">
                <BookOpen size={80} className="text-white opacity-80" />
                <div className="absolute inset-0 bg-[url('https://www.thetransformationcollective.org/wp-content/uploads/2025/11/book1.png')] bg-center bg-cover"></div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Lord Build Me A House</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  We all have a time to be called by God, and we have the choice to accept Him or reject Him. Lord, Build Me a House is a book designed to educate and guide readers to a higher standard of Kingdom living.
                </p>
                <div className="flex gap-3">
                  <button onClick={() => { window.location.href = "/checkout?id=standard" }} className="flex-1 px-6 py-3 bg-red-700 text-white rounded-lg font-medium hover:bg-red-800 transition-colors duration-300">
                    Purchase
                  </button>
                  <button onClick={() => { window.location.href = "/book-detail?id=16" }} className="px-6 py-3 border-2 border-red-700 text-red-700 rounded-lg font-medium hover:bg-red-50 transition-colors duration-300">
                    Preview
                  </button>
                </div>
                <p>available on all online <a className='text-orange-600' href='https://a.co/d/bnWXYPk'>books stores.</a></p>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all duration-500 hover:scale-105 hover:shadow-2xl">
              <div className="relative h-64 bg-gradient-to-br from-orange-600 to-red-700 flex items-center justify-center">
                <BookOpen size={80} className="text-white opacity-80" />
                <div className="absolute inset-0 bg-[url('https://www.thetransformationcollective.org/wp-content/uploads/2025/11/book2.png')] bg-center bg-cover"></div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">The Shift Of Thrones</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  We all have a time to be called by God, and we have the choice to accept Him or reject Him. Lord, Build Me a House is a book designed to educate and guide readers to a higher standard of Kingdom living.
                </p>
                <div className="flex gap-3">
                  <button onClick={() => setPreReleaseModalOpen(true)} className="flex-1 px-6 py-3 bg-red-700 text-white rounded-lg font-medium hover:bg-red-800 transition-colors duration-300">
                    Purchase
                  </button>
                  <button onClick={() => { window.location.href = "/book-detail?id=2" }} className="px-6 py-3 border-2 border-red-700 text-red-700 rounded-lg font-medium hover:bg-red-50 transition-colors duration-300">
                    Preview
                  </button>
                </div>
                <p>available on all online <a className='text-orange-600' href='https://www.amazon.com/dp/B0FZMTS86P?ref_=cm_sw_r_ffobk_cp_ud_dp_K0XZ1JD7GJEW1E17TD3N'>books stores</a>.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Parallax Section 2: Scroll-Controlled Video */}
      <div className="hidden md:block">
        <ParallaxContent
          imgUrl="https://www.thetransformationcollective.org/wp-content/uploads/2025/11/WhatsApp-Image-2025-11-20-at-3.42.45-PM.jpeg"
          subheading="Connect with a community of believers, access powerful teachings, and experience the transformative power of prayer together."
          heading="Join the Prayer Movement"
          button1="Join the Prayer Movement"
          button1Url="https://www.youtube.com/@latangelarogers"
          button2="Learn More"
          button2Url="/glory-hour"
        />
      </div>

      <div className="block md:hidden p-3">
        <div className="w-full h-[400px] bg-center bg-cover mb-8 rounded-lg shadow-lg"
          style={{
            background: "url(https://www.thetransformationcollective.org/wp-content/uploads/2025/11/WhatsApp-Image-2025-11-20-at-3.42.45-PM.jpeg) center no-repeat",
            backgroundSize: "cover"
          }}
        ></div>
        <h1 className="text-md font-bold text-gray-900 mb-6 text-center">
          Connect with a community of believers, access powerful teachings, and experience the transformative power of prayer together.
        </h1>
        <div className="flex gap-3">
          <button onClick={() => { window.location.href = "https://www.youtube.com/@latangelarogers" }} className="flex-1 px-6 py-3 bg-black text-white rounded-lg font-medium hover:bg-red-950 transition-colors duration-300">
            Join the Prayer Movement
          </button>
          <button onClick={() => { window.location.href = "/glory-hour" }} className="px-6 py-3 border-2 border-black text-red-950 rounded-lg font-medium hover:bg-red-50 transition-colors duration-300">
            Learn More
          </button>
        </div>
      </div>

      {/* About  Section */}
      <section id="bio-preview" className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 animate-fade-in">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">About Me</h2>
            <div className="w-20 h-1 bg-red-700 mx-auto"></div>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-xl p-8 md:p-12 transform transition-all duration-500 hover:shadow-2xl">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Latangela Rogers is a prophetic voice, reformer, and visionary leader called to awaken a generation to divine purpose, order, and destiny. With over fifteen years of experience in leadership, workforce development, local government, non-profit sector, and community empowerment, she has become a respected voice of transformation, bridging faith, leadership, and social impact.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Latangela holds a B.A. in Management and an M.A. in Human Behavior, and is currently pursuing her Doctorate in Organizational Leadership. Her professional and ministry experience uniquely position her at the intersection of prophetic discernment and practical leadership. She has dedicated her life to equipping leaders to hear, build, and govern according to Heaven’s blueprint.
            </p>

            <button
              onClick={() => onNavigate('biography')}
              className="inline-flex items-center gap-2 text-red-700 font-semibold hover:text-red-800 transition-colors duration-300 group"
            >
              Read Full Biography
              <ArrowRight size={20} className="transform group-hover:translate-x-2 transition-transform duration-300" />
            </button>
          </div>
        </div>
      </section>

      {/* Prayer Request Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-800 relative overflow-hidden">
        <ReturnBG index={2} opacity={0.1} />
        <div className="max-w-4xl mx-auto text-center">
          <AnimatedSection>
            <div className="w-20 h-20 bg-gradient-to-r from-amber-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-8">
              <Heart className="w-10 h-10 text-white" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-100 mb-6">
              Need Prayer?
            </h2>
            <p className="text-xl text-gray-100 mb-8 max-w-2xl mx-auto">
              You're not alone. Share your prayer needs with our community and experience the power of collective prayer.
            </p>
            <button
              onClick={() => setPrayerModalOpen(true)}
              className="bg-gradient-to-r from-amber-500 to-purple-600 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
            >
              <MessageCircle className="w-5 h-5 inline mr-2" />
              Submit Prayer Request
            </button>
          </AnimatedSection>
        </div>
      </section>


      {/* Ministries Section */}
      <section id="ministries-section" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 animate-fade-in">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Ministries</h2>
            <div className="w-20 h-1 bg-red-700 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Serving God through various ministries and outreach programs
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <a
              href="https://www.roseofjericho-cd.org"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-xl p-8 transform transition-all duration-500 hover:scale-105 hover:shadow-2xl"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-red-600 to-orange-700 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <Users size={32} className="text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Rose of Jericho Community Development</h3>
              <p className="text-gray-600 mb-4 leading-relaxed">
                Empowering women to discover their purpose and walk in faith through fellowship, study, and prayer.
              </p>
              <span className="inline-flex items-center gap-2 text-red-700 font-semibold group-hover:gap-4 transition-all duration-300">
                Visit Ministry <ArrowRight size={20} />
              </span>
            </a>

            <a
              href="https://www.thetransformationcollective.org"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-xl p-8 transform transition-all duration-500 hover:scale-105 hover:shadow-2xl"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-red-600 to-orange-700 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <Heart size={32} className="text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">The Transformation Collective Leadership Academy</h3>
              <p className="text-gray-600 mb-4 leading-relaxed">
                Inspiring the next generation to build a strong foundation in Christ through mentorship and guidance.
              </p>
              <span className="inline-flex items-center gap-2 text-red-700 font-semibold group-hover:gap-4 transition-all duration-300">
                Visit Ministry <ArrowRight size={20} />
              </span>
            </a>

            {/* <a
              href="https://example-teaching-ministry.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-xl p-8 transform transition-all duration-500 hover:scale-105 hover:shadow-2xl"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-red-600 to-orange-700 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <BookOpen size={32} className="text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Teaching Ministry</h3>
              <p className="text-gray-600 mb-4 leading-relaxed">
                Equipping believers with sound biblical teaching and practical application for victorious living.
              </p>
              <span className="inline-flex items-center gap-2 text-red-700 font-semibold group-hover:gap-4 transition-all duration-300">
                Visit Ministry <ArrowRight size={20} />
              </span>
            </a> */}
          </div>
        </div>
      </section>

      <PreReleaseModal
        isOpen={preReleaseModalOpen}
        onClose={() => setPreReleaseModalOpen(false)}
        onContinue={() => {
          setPreReleaseModalOpen(false)
          window.location.href = "/checkout?id=pre-release"
        }}
      />
      <PrayerRequestModal isOpen={prayerModalOpen} onClose={() => setPrayerModalOpen(false)} />
    </div>
  );
}




// Animation hook for scroll-triggered animations
const useScrollAnimation = () => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return { ref, isVisible };
};


// Animated Section wrapper component
// const AnimatedSection: React.FC<{ children: React.ReactNode; className?: string; delay?: number }> = ({ 
const AnimatedSection = ({
  children,
  className = "",
  delay = 0
}) => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <div
      ref={ref}
      className={`transition-all duration-1000 ease-out ${isVisible
        ? 'opacity-100 translate-y-0'
        : 'opacity-0 translate-y-8'
        } ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};
// Email Signup Modal Component
// const EmailSignupModal: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => {
const EmailSignupModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({ name: '', email: '' });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would normally send data to your backend
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      onClose();
      setFormData({ name: '', email: '' });
    }, 3000);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full transform transition-all duration-300 scale-100">
        {!isSubmitted ? (
          <>
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-r from-purple-600 to-purple-800 rounded-full flex items-center justify-center mx-auto mb-4">
                <Mail className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">Join the Prayer Movement</h3>
              <p className="text-gray-600">Connect with our spiritual community and receive updates</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <input
                  type="text"
                  placeholder="Full Name (Optional)"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200"
                />
              </div>
              <div>
                <input
                  type="email"
                  placeholder="Email Address *"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200"
                />
              </div>
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-purple-600 to-purple-800 text-white py-3 rounded-lg font-semibold hover:shadow-lg transform hover:scale-[1.02] transition-all duration-200"
              >
                Join the Movement
              </button>
            </form>

            <button
              onClick={onClose}
              className="mt-4 w-full text-gray-500 hover:text-gray-700 transition-colors duration-200"
            >
              Close
            </button>
          </>
        ) : (
          <div className="text-center py-8">
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h3 className="text-2xl font-bold text-gray-800 mb-2">You're in!</h3>
            <p className="text-gray-600">Check your inbox for access and welcome information.</p>
          </div>
        )}
      </div>
    </div>
  );
};

// Prayer Request Modal Component
// const PrayerRequestModal: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => {
const PrayerRequestModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({ name: '', email: '', prayerNeed: '', schedule: '' });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      onClose();
      setFormData({ name: '', email: '', prayerNeed: '', schedule: '' });
    }, 3000);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full max-h-[90vh] overflow-y-auto">
        {!isSubmitted ? (
          <>
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-r from-amber-500 to-amber-700 rounded-full flex items-center justify-center mx-auto mb-4">
                <Heart className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">Prayer Request</h3>
              <p className="text-gray-600">Let us pray with you and for you</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <input
                  type="text"
                  placeholder="Your Name *"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-200"
                />
              </div>
              <div>
                <input
                  type="email"
                  placeholder="Email Address *"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-200"
                />
              </div>
              <div>
                <textarea
                  placeholder="Prayer Need *"
                  value={formData.prayerNeed}
                  onChange={(e) => setFormData({ ...formData, prayerNeed: e.target.value })}
                  required
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-200 resize-none"
                />
              </div>
              <div>
                <select
                  value={formData.schedule}
                  onChange={(e) => setFormData({ ...formData, schedule: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-200"
                >
                  <option value="">Preferred Prayer Session (Optional)</option>
                  <option value="morning">Morning Prayer (8AM EST)</option>
                  <option value="evening">Evening Prayer (7PM EST)</option>
                  <option value="weekend">Weekend Sessions</option>
                  <option value="private">Private Prayer Request</option>
                </select>
              </div>
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-amber-500 to-amber-700 text-white py-3 rounded-lg font-semibold hover:shadow-lg transform hover:scale-[1.02] transition-all duration-200"
              >
                Submit Prayer Request
              </button>
            </form>

            <button
              onClick={onClose}
              className="mt-4 w-full text-gray-500 hover:text-gray-700 transition-colors duration-200"
            >
              Close
            </button>
          </>
        ) : (
          <div className="text-center py-8">
            <Heart className="w-16 h-16 text-amber-500 mx-auto mb-4" />
            <h3 className="text-2xl font-bold text-gray-800 mb-2">Prayer Received</h3>
            <p className="text-gray-600">Your prayer request has been received. We will be praying for you.</p>
          </div>
        )}
      </div>
    </div>
  );
};
